import React from 'react'
import { Box, Flex, FlexProps, Text } from '@chakra-ui/core'
import { useDropzone } from 'react-dropzone'
import useLocaleText from './useLocaleText'

interface DropzoneProps {
  onDrop: (files: File[]) => void
  onPaste: (event: React.ClipboardEvent) => void
  noClick?: boolean
  noKeyboard?: boolean
  disabled?: boolean
}

type DropzoneWrapperProps = DropzoneProps & Omit<FlexProps, 'onDrop'>

export const DropzoneWrapper: React.FC<DropzoneWrapperProps> = ({
  onDrop,
  onPaste,
  children,
  noClick = true,
  noKeyboard = true,
  disabled = false,
  ...boxProps
}) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    noClick: disabled ? true : noClick,
    noKeyboard: disabled ? true : noKeyboard,
    disabled,
  })
  const t_drop_zone_text = useLocaleText('drop_zone_text')

  return (
    <Flex
      {...getRootProps()}
      w="100%"
      alignItems="center"
      justifyContent="center"
      onPaste={onPaste}
      border={isDragActive ? '4px dashed' : 'none'}
      borderColor={isDragActive ? 'gray.200' : 'transparent'}
      transition="all 0.2s ease-in-out"
      position="relative"
      {...boxProps}
    >
      <input {...getInputProps()} onClick={(e) => e.preventDefault()} style={{ display: 'none' }} />
      <Box
        opacity={isDragActive ? 0.5 : 1}
        style={{ filter: isDragActive ? 'blur(8px)' : 'none' }}
        transform={isDragActive ? 'scale(0.95)' : 'scale(1)'}
        transition="all 0.2s ease-in-out"
        w="100%"
      >
        {children}
      </Box>
      {isDragActive && (
        <Box position="absolute" top="50%" left="50%" transform="translate(-50%, -50%)" zIndex={1}>
          <Text
            fontSize="xl"
            bg="transparent"
            fontWeight="bold"
            color="gray.600"
            textAlign="center"
            p={2}
            borderRadius="md"
          >
            {t_drop_zone_text}
          </Text>
        </Box>
      )}
    </Flex>
  )
}
